module.exports = __webpack_public_path__ + "img/15.9611e089.jpeg";